// Removes keys with a nullish value from an object
export default function deleteNil<T extends Record<string, unknown>>(
  object: Partial<T>
): Partial<T> {
  return Object.entries(object).reduce((result, [key, value]) => {
    if (value != null) {
      (result as T)[key as keyof T] = value as T[keyof T];
    }
    return result;
  }, {} as Partial<T>);
}
